export default "__VITE_ASSET__DlthWS$3__"